module.exports = __webpack_public_path__ + "img/bp-small.b57cb03e.png";